import { useTranslation } from "react-i18next";

export default function ContactCards() {
  const { t } = useTranslation("contact");
  const cards = [
    {
      icon: "ri-phone-line",
      label: t("cards.card1.label"),
      value: t("cards.card1.value"),
      href: "tel:" + t("cards.card1.tel"),
      note: t("cards.card1.note"),
    },
    {
      icon: "ri-mail-line",
      label: t("cards.card2.label"),
      value: t("cards.card2.value"),
      href: "mailto:" + t("cards.card2.mailto"),
      note: t("cards.card2.note"),
    },
    {
      icon: "ri-map-pin-2-line",
      label: t("cards.card3.label"),
      value: t("cards.card3.value"),
      note: t("cards.card3.note"),
    },
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("cards.h2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 md:p-8 border border-brand-border hover:border-brand-yellow transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-yellow mb-4 md:mb-5">
                <i className={`${card.icon} text-brand-text text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <p className="font-geist-mono text-xs font-bold tracking-wider text-brand-text/60 mb-2">
                {card.label}
              </p>
              {card.href ? (
                <a
                  href={card.href}
                  className="font-geist-mono font-bold text-2xl md:text-[32px] text-brand-text hover:text-brand-blue transition-colors block mb-3 md:mb-4"
                >
                  {card.value}
                </a>
              ) : (
                <p className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-3 md:mb-4">
                  {card.value}
                </p>
              )}
              <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                {card.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}